module.exports = __webpack_public_path__ + "static/media/base-map-button-street-view.08454906.png";